import { MsalProvider } from '@azure/msal-react';
import { authenticationClientProvider, EnvConfig } from '@config';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AuthenticationProvider from 'components/AuthenticationProvider';
import { WindowContextProvider } from 'components/WindowContext/WindowContext';
import React, { useEffect } from 'react';
import { hotjar } from 'react-hotjar';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Store } from 'redux';

import Root from './components/Root';
import Routes from './routes';

interface Props {
  store: Store;
}

const theme = createTheme({});

const App: React.FunctionComponent<Props> = ({ store }) => {
  useEffect(() => {
    const siteId = EnvConfig.hotjar_site_id;
    const hotjarVersion = 6;
    try {
      if (siteId && siteId.length > 0) {
        hotjar.initialize({ id: Number(siteId), sv: hotjarVersion });
      }
    } catch (e) {
      console.error('Error initializing Hotjar', e);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <WindowContextProvider>
          <BrowserRouter>
            <MsalProvider instance={authenticationClientProvider}>
              <AuthenticationProvider>
                <Root>
                  <Routes />
                </Root>
              </AuthenticationProvider>
            </MsalProvider>
          </BrowserRouter>
        </WindowContextProvider>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
